// extracted by mini-css-extract-plugin
module.exports = {"invitationWrapper":"_shareId__invitationWrapper__l1wvL","joinInvitationText":"_shareId__joinInvitationText__7L_bI"};